(function () {

    "use strict";

    // Translations
    function translationConfiguration($translateProvider, tmhDynamicLocaleProvider) {

        $translateProvider
            .useSanitizeValueStrategy("escape")
            .registerAvailableLanguageKeys(["en", "es", "ca"], {
                'en_GB': "en",
                'es_ES': "es",
                'ca_ES': "ca",
                'en*': "en",
                'es*': "es",
                '*': 'en'
            })
            .fallbackLanguage("es")
            //.determinePreferredLanguage()
            .preferredLanguage("es")
            .useLocalStorage()
            .useMissingTranslationHandler("translate.customMissingTranslationHandler")
            //.useMissingTranslationHandlerLog()
            .useStaticFilesLoader({
                prefix: "app/i18n/",
                suffix: ".locale.json"
            });

        tmhDynamicLocaleProvider.localeLocationPattern("/app/i18n/angular-locale_{{locale}}.js");
    }

    translationConfiguration.$inject = ["$translateProvider", "tmhDynamicLocaleProvider"];
    
    angular.module("sphforms.translate")
        .config(translationConfiguration);

}());
